/**
 * Servicio que conecta con la API los comentarios de las incidencias
 */
ComentarioIncidenciaDataService.$inject = ['$resource'];
export default function ComentarioIncidenciaDataService($resource) {
    return $resource(Sigo.var.path + '/api/v1' + '/incidencias' + '/:incidenciaId/comentarios/:comentarioId', {
            incidenciaId: '@incidenciaId',
            comentarioId: '@comentarioId'
        }, {
            'update': {method: 'PUT'}
        }
    );
}